import React, { memo } from "react";

import Subscription from "./components/Subscription";
import Links from "./components/Links";
import Categories from "./components/Categories";
import Terms from "./components/Terms";

function Footer() {
    return (
        <>
            <Subscription />
            <Links />
            <Categories />
            <Terms />
        </>
    );
}

export default memo(Footer);
